import { render, staticRenderFns } from "./rolegroup-edit.vue?vue&type=template&id=0e4aa28e&"
import script from "./rolegroup-edit.vue?vue&type=script&lang=js&"
export * from "./rolegroup-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4aa28e')) {
      api.createRecord('0e4aa28e', component.options)
    } else {
      api.reload('0e4aa28e', component.options)
    }
    module.hot.accept("./rolegroup-edit.vue?vue&type=template&id=0e4aa28e&", function () {
      api.rerender('0e4aa28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/usermgmt/rolegroup-edit.vue"
export default component.exports